import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBase } from './selectBase'

export const selectInboxProduct = createSelector(
  selectBase,
  base => base.inbox || emptyObj
)
